import useBootstrapData from '@/hooks/useBootstrapData'
import { useRouter } from 'next/router'
import { Box, Divider } from 'pcln-design-system'
import { StyledImage } from './Cobrand.styled'
import getCobrandContent from './constants'

// Displays when users are navigated to Priceline through referral partners

export default function Cobrand() {
  const { referral: { id = '', sourceId = '' } = {} } = useBootstrapData()
  const { query } = useRouter()
  const refid = sourceId + id
  const promo = getCobrandContent(refid)

  return promo && query?.refid ? (
    <Box color='background.lightest' width={1}>
      <Divider borderColor='border.base' my={0} />
      <StyledImage alt={promo.alt} src={promo.src} />
    </Box>
  ) : null
}
